<template>
  <div
    class="global-search wc"
    :class="{
      black_bar: black_bar,
      about_us: !project_type
    }"
  >
    <div class="global-search__inner">
      <div
        class="search__input_wrapper global-search__input_wrapper"
        ref="search_bar"
      >
        <div class="container">
          <el-input
            :placeholder="$fn.tr('ძიება')"
            v-model="search_val"
            class="uppercase bold"
          ></el-input>
          <div
            class="global-search__input_wrapper--x_btn pointer"
            @click="toggle_search()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.75"
              height="22.75"
              viewBox="0 0 22.75 22.75"
            >
              <path
                id="Icon_metro-cancel"
                data-name="Icon metro-cancel"
                d="M28.768,9.64l-7.11,7.11-7.11-7.11-4.266,4.266,7.11,7.11-7.11,7.11,4.266,4.266,7.11-7.11,7.11,7.11,4.266-4.266-7.11-7.11,7.11-7.11Z"
                transform="translate(-10.283 -9.64)"
                fill="#4d4d4f"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        class="global-search__results"
        ref="results"
        :style="{
          backgroundColor: not_typed
            ? 'rgba(255, 255, 255, 0)'
            : 'rgba(255, 255, 255, 1)'
        }"
      >
        <transition name="fade-bg">
          <div
            class="global-search__results--overlay events-none"
            v-if="transitioned"
            :style="{
              backgroundColor: not_typed
                ? 'rgba(26, 26, 26, 0.5)'
                : 'rgba(26, 26, 26, 0)'
            }"
          ></div>
        </transition>

        <div
          class="global-search__results--inner"
          :style="{ opacity: !not_typed ? 1 : 0 }"
        >
          <div
            class="global-search__results--header pt-55 "
            :style="{ backgroundColor: stores ? '#f7f7f7' : 'white' }"
          >
            <div class="container flex column pb-55">
              <span class="font-21 bold uppercase">{{
                $fn.tr("შედეგები")
              }}</span>
              <span class="font-16 medium"
                >{{ $fn.tr("ნაპოვნია") }} &nbsp;
                <span class="f-red">{{
                  news.length + offers.length + stores.length + vacancies.length
                }}</span
                >&nbsp;{{ $fn.tr("შედეგი") }}</span
              >
            </div>

            <div
              class="global-search__not-found flex justify-center pt-55 pb-55 pl-10 pr-10"
              v-if="not_found && !not_typed"
            >
              <h2 class="font-55 bold f-center">
                {{ $fn.tr("შედეგი ვერ მოიძებნა") }}
              </h2>
            </div>
          </div>

          <div class="global-search__results--shops" v-if="stores.length >= 1">
            <div class="container">
              <h2 class="font-34 bold uppercase">{{ $fn.tr("მაღაზიები") }}</h2>
            </div>
            <div class="grid container">
              <BrandCard
                @click.native="open_modal(shop)"
                v-for="shop in stores"
                :brand="shop"
                :key="shop.id"
              />
            </div>
          </div>

          <div
            class="global-search__results--offers container pt-89 pb-89"
            v-if="offers_sliced"
          >
            <h2 class="font-34 bold uppercase">
              {{ $fn.tr("შეთავაზებები") }}
            </h2>
            <div class="grid pt-55 pb-144">
              <OfferCard
                v-for="offer in offers_sliced"
                :offer="offer"
                :key="offer.id"
              />
            </div>
            <div
              v-if="offers_sliced.length !== offers.length"
              class="global-search__show-more flex al-center justify-center pt-24 pb-24 bg-yellow f-white bold uppercase pointer"
              @click="show_more(offers_sliced.length, 'offers')"
            >
              {{ $fn.tr("მაჩვენე მეტი") }}
            </div>
          </div>
          <div
            class="container global-search__results--news"
            v-if="news.length >= 1"
          >
            <h2 class="font-34 bold uppercase">{{ $fn.tr("სიახლეები") }}</h2>

            <div class="grid">
              <NewsCard
                :data="item"
                :key="index"
                v-for="(item, index) in news_sliced"
              />
            </div>
            <div
              v-if="news_sliced.length !== news.length"
              class="global-search__show-more flex al-center justify-center pt-24 pb-24 bg-yellow f-white bold uppercase pointer"
              @click="show_more(news_sliced.length, 'news')"
            >
              {{ $fn.tr("მაჩვენე მეტი") }}
            </div>
          </div>

          <div
            class="container global-search__results--vacancies pt-89"
            v-if="vacancies.length >= 1"
          >
            <h2 class="font-34 bold uppercase mb-14">
              {{ $fn.tr("ვაკანსიები") }}
            </h2>

            <div class="flex column">
              <div
                :key="index"
                v-for="(item, index) in vacancies"
                class="flex column pt-55"
              >
                <span class="bold font-21 uppercase">{{
                  _.get(item, "title")
                }}</span>
                <div
                  class="global-search__results--vacancies__breadcrumb flex al-center mb-13 mt-14"
                >
                  <router-link
                    :to="
                      $store.state.main.indx.menus.filter(
                        m => m.url_slug == $route.params.path1
                      )[0].full_url
                    "
                    class="f-16 bold f-black"
                  >
                    {{ $fn.tr("მთავარი") }}
                  </router-link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6.286"
                    height="8"
                    viewBox="0 0 6.286 8"
                    class="ml-10 mr-10"
                  >
                    <path
                      id="Icon_material-play-arrow"
                      data-name="Icon material-play-arrow"
                      d="M18.286,7.5v8L12,11.5Z"
                      transform="translate(18.286 15.5) rotate(180)"
                      fill="#1a1a1a"
                    />
                  </svg>
                  <router-link
                    :to="
                      $store.state.main.indx.menus.filter(m =>
                        m.configs.includes('vacancies')
                      )[0].full_url
                    "
                    class="f-16 bold f-black"
                  >
                    {{ $fn.tr("კარიერა") }}
                  </router-link>
                </div>
                <div
                  class="global-search__results--vacancies__teaser"
                  v-html="_.get(item, 'content')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import BrandCard from "@/components/smartComponents/BrandCard";
import NewsCard from "@/components/smartComponents/NewsCard";
import OfferCard from "@/components/smartComponents/OfferCard";
export default {
  props: ["black_bar"],
  mixins: [resize_handler],
  components: { BrandCard, NewsCard, OfferCard },

  data() {
    return {
      time_out: "",
      not_typed: true,
      search_val: "",
      search_results: "",
      stores: "",
      vacancies: "",
      news: "",
      news_sliced: "",
      offers: "",
      offers_sliced: "",
      not_found: false
    };
  },
  computed: {
    search_toggler() {
      return this.$store.state.main.global_search_toggler;
    },
    transitioned() {
      return this.$store.state.main.global_search_beforeClose;
    },
    project_type() {
      if (
        this.$route.params.path1 == "saburtalo" ||
        this.$route.params.path1 == "gldani"
      ) {
        return this.$store.state.main.indx.terms.project.filter(
          pr => pr.slug === this.$route.params.path1
        )[0];
      } else {
        return;
      }
    }
  },
  mounted() {
    this.$refs.results.style.height = `${this.windowHeight -
      this.$refs.search_bar.getBoundingClientRect().bottom}px`;
    this.time_out = setTimeout(() => {
      // this.transitioned = true;
      this.$store.commit("main/setState", {
        key: "global_search_beforeClose",
        val: true
      });
    }, 400);
  },

  methods: {
    toggle_search() {
      if (this.search_toggler == false) {
        this.$store.commit("main/setState", {
          key: "global_search_toggler",
          val: true
        });
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      } else {
        this.$store.commit("main/setState", {
          key: "global_search_beforeClose",
          val: false
        });

        setTimeout(() => {
          this.$store.commit("main/setState", {
            key: "global_search_toggler",
            val: false
          });
        }, 400);
      }
    },
    async search() {
      let tmp = await this.$fn.postData("main/search", {
        searchWord: this.search_val
      });
      this.search_results = tmp.data;
      this.filter_results(this.search_results.content);
    },

    filter_results(results) {
      let menus = this.$store.state.main.indx.menus,
        shops = [],
        news = [],
        offers = [],
        vacancies = [];
      this.stores = "";
      this.news = "";
      this.offers = "";
      this.vacancies = "";
      if(this.search_val.length >= 2){

      
      for (let j = 0; j < results.length; j++) {
        let cont_type;
        cont_type = results[j].content_type;
        if (this.project_type) {
          if (
            cont_type == "stores" &&
            results[j].project &&
            results[j].project.length >= 1 &&
            results[j].project[0] == this.project_type.id
          ) {
            shops.push(results[j]);
            this.stores = shops;
          }
          if (
            cont_type == "news" &&
            results[j].project &&
            results[j].project.length >= 1 &&
            results[j].project.includes(this.project_type.id)
          ) {
            news.push(results[j]);
            this.news = news;
          }

          if (
            cont_type == "offers" &&
            results[j].project &&
            results[j].project.length >= 1 &&
            results[j].project.includes(this.project_type.id)
          ) {
            offers.push(results[j]);
            this.offers = offers;
          }
        } else {
          if (cont_type == "stores") {
            shops.push(results[j]);
            this.stores = shops;
          }
          if (cont_type == "news") {
            news.push(results[j]);
            this.news = news;
          }

          if (cont_type == "offers") {
            offers.push(results[j]);
            this.offers = offers;
          }
        }

        if (cont_type == "vacancy") {
          vacancies.push(results[j]);
          this.vacancies = vacancies;
        }
      }

      }

      this.news.length +
        this.offers.length +
        this.stores.length +
        this.vacancies.length ==
        0 && this.search_val.length >= 2
        ? (this.not_found = true)
        : (this.not_found = false);

      if (this.search_val.length >= 2) this.not_typed = false;
    },

    show_more(len, data_type) {
      data_type == "offers"
        ? (this.offers_sliced = this.offers.slice(0, len + 2))
        : (this.news_sliced = this.news.slice(0, len + 3));
    }
  },
  watch: {
    not_typed(ns) {
      this.$refs.results.style.height = `${this.windowHeight -
        this.$refs.search_bar.getBoundingClientRect().bottom}px`;
        console.log(ns)
    },
    search_val(ns) {
      if (ns.length >= 2) {
        setTimeout(() => {
          this.search(ns);
        }, 300);
      } else {
        this.not_typed = true;
      }

            this.$refs.results.style.height = `${this.windowHeight -
        this.$refs.search_bar.getBoundingClientRect().bottom}px`;
    },

    windowHeight(ns) {
      this.$refs.results.style.height = `${this.windowHeight -
        this.$refs.search_bar.getBoundingClientRect().bottom}px`;
    },
    stores(ns) {},
    offers(ns) {
      this.offers_sliced = this.offers.slice(0, 2);
    },
    news(ns) {
      this.news_sliced = this.news.slice(0, 3);
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-bg {
  &-enter {
    opacity: 0;
    transition: 0.6s;
    &-to {
      opacity: 1;
      transition: 0.6s;
    }
  }
  &-leave {
    opacity: 1;
    transition: 0.6s;

    &-to {
      opacity: 0;
      transition: 0.6s;
    }
  }
}
.global-search {
  position: absolute;
  top: 150px;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 99;

  &__input_wrapper {
    position: relative;
    padding-top: 32px;
    padding-bottom: 34px;
    overflow: hidden;
    .container {
      position: relative;
    }
    &--x_btn {
      position: absolute;
      top: 10px;
      right: 0;
      cursor: pointer;
      z-index: 20;
      pointer-events: all;
      height: 20px;
      width: 20px;
      @media (max-width: 1125px) {
        right: 59px;
      }
      @media (max-width: 1023px) {
        right: 45px;
      }
      @media (max-width: 767px) {
        right: 15px;
      }
      svg {
        position: relative;
        top: initial;
        right: initial;
        pointer-events: all;
        path {
          transition: 0.4s;
        }
      }
      @include hover {
        svg path {
          fill: $red;
        }
      }
    }
    &:after {
      transition: 0.2s ease;
      position: absolute;
      content: "";
      width: 100%;
      height: 2px;
      left: 0;
      bottom: 0;
      background: linear-gradient(
        to right,
        #40adec 0%,
        #426ab3 20%,
        #3269e5 30%,
        #ffcb05 40%,
        #ffc900 50%,
        #ffc900 50%,
        #e11f26 60%,
        #e50b09 100%
      );
    }
  }
  &.black_bar {
    top: 195px;
  }
  &.about_us {
    top: 94px;
  }
  &__results {
    position: absolute;
    left: 0;
    top: 112px;
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    overflow-y: auto;
    transition: 0.4s;
    padding-bottom: 146px;
    @media (max-width: 1439px) {
      top: 113px;
    }
    @media (max-width: 767px) {
      top: 96px;
    }
    &--overlay {
      background-color: rgba(26, 26, 26, 0);
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transition: 0.38s;
    }
    &--header {
      transition: 0.4s;
      .container {
        border-bottom: 1px solid rgba(26, 26, 26, 0.1);
      }
    }
    &--shops {
      background-color: #f7f7f7;
      padding-bottom: 91px;
      padding-top: 55px;
      .grid {
        position: relative;
        padding-top: 55px;

        display: grid;
        grid-template-columns: repeat(3, minmax(0px, 1fr));
        grid-gap: 30px;

        @media (max-width: 1023px) {
          grid-template-columns: repeat(2, minmax(0px, 1fr));
          grid-gap: 15px;
        }
        @media (max-width: 767px) {
          grid-template-columns: repeat(1, minmax(0px, 1fr));
        }
      }
    }
    &--news {
      padding-top: 89px;
      .grid {
        display: grid;
        padding-top: 55px;
        padding-bottom: 89px;
        grid-row-gap: 89px;
        grid-column-gap: 30px;
        grid-template-columns: repeat(3, minmax(0px, 1fr));
        border-bottom: 1px solid rgba(26, 26, 26, 0.1);

        @media (max-width: 1023px) {
          grid-template-columns: repeat(2, minmax(0px, 1fr));
          grid-gap: 15px;
        }
        @media (max-width: 767px) {
          grid-template-columns: repeat(1, minmax(0px, 1fr));
        }
      }
    }
    &--vacancies {
      &__teaser {
        &::v-deep {
          @include clamp(2);
        }
      }
    }
    &--offers {
      border-bottom: 1px solid rgba(26, 26, 26, 0.1);

      .grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0px, 1fr));
        grid-column-gap: 30px;
        grid-row-gap: 89px;

        @media (max-width: 767px) {
          grid-row-gap: 55px;
          padding-top: 55px;
        }
        @media (max-width: 767px) {
          grid-column-gap: 0px;

          grid-template-columns: repeat(1, minmax(0px, 1fr));
        }
      }
    }
  }
  @media (max-width: 1023px) {
    z-index: 9999999;
    top: 150px;
    &.black_bar {
      top: 150px;
    }
    &__not-found {
      h2 {
        font-size: 34px;
      }
    }
    &__results {
      padding-bottom: 89px;
      &--news {
        padding-top: 55px;
        .grid {
          padding-bottom: 55px;
        }
      }
      &--vacancies {
        padding-top: 55px;
        .pt-55 {
          padding-top: 34px;
        }
      }
      &--shops {
        padding-bottom: 55px;
      }
    }
  }
}
</style>
